import React from "react";
import {
  Box,
  Typography,
  Grid,
  Stack,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import {
  HelpOutline as HelpIcon,
  ExpandMore as ExpandMoreIcon,
  TouchAppOutlined as PickStepIcon,
  VerifiedUserOutlined as FairStepIcon,
  MonetizationOnOutlined as WinStepIcon,
} from "@mui/icons-material";
import { colors, borderRadiusPx } from "../../../../../theme";
import { LOTTERY_NAMES } from "../../../../../static/Constants";

const STEPS = [
  {
    step: "01",
    icon: PickStepIcon,
    title: "Select an Open Minefield",
    desc: `Browse through live ${LOTTERY_NAMES.MINEBET} games created by verified creators with custom entry fees and jackpot prize pools.`,
  },
  {
    step: "02",
    icon: FairStepIcon,
    title: "Pick Your 1 Lucky Tile",
    desc: "Select 1 available ticket coordinate on the minefield grid or use Random Pick to choose an unsold tile.",
  },
  {
    step: "03",
    icon: WinStepIcon,
    title: "Decentralized VRF Winner",
    desc: "Once the grid fills or timer ends, Chainlink VRF randomly determines the winning coordinate. Payout is dispatched directly to the winner's wallet!",
  },
];

const FAQS = [
  {
    q: `How is the winning tile chosen in ${LOTTERY_NAMES.MINEBET}?`,
    a: "The winning ticket coordinate is chosen on-chain using Chainlink Verifiable Random Function (VRF), ensuring provably fair and tamper-proof outcomes that cannot be manipulated by creators or players.",
  },
  {
    q: `What happens if a ${LOTTERY_NAMES.MINEBET} lottery has Rollover status?`,
    a: "If a game rolls over, the accumulated prize pool carries forward into the next round, increasing the total reward pot for participating players.",
  },
  {
    q: "When are winnings paid out?",
    a: "Winnings are distributed automatically and immediately to the winning player's connected Web3 wallet by the smart contract upon result resolution.",
  },
];

const MineHowToPlay = () => {
  return (
    <Box sx={{ mt: 6, mb: 4 }}>
      {/* 3 Steps Overview */}
      <Box
        sx={{
          bgcolor: colors.dashboard.cardBg,
          borderRadius: borderRadiusPx.xl,
          border: `1px solid ${colors.dashboard.cardBorder}`,
          p: { xs: 3, md: 4 },
          mb: 3,
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 3 }}>
          <Box
            sx={{
              width: 36,
              height: 36,
              borderRadius: borderRadiusPx.md,
              bgcolor: colors.purple[50],
              color: colors.purple[600],
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <HelpIcon sx={{ fontSize: 20 }} />
          </Box>
          <Box>
            <Typography
              variant="h6"
              sx={{ fontWeight: 700, color: colors.slate[900], fontSize: "1.1rem" }}
            >
              How Autobet Mine Works
            </Typography>
            <Typography variant="body2" sx={{ color: colors.slate[500] }}>
              A 3-step decentralized tactical number guessing game
            </Typography>
          </Box>
        </Stack>

        <Grid container spacing={3}>
          {STEPS.map((item, idx) => {
            const StepIcon = item.icon;
            return (
              <Grid item xs={12} md={4} key={idx}>
                <Box
                  sx={{
                    p: 2.5,
                    bgcolor: colors.slate[50],
                    borderRadius: borderRadiusPx.lg,
                    border: `1px solid ${colors.slate[200]}`,
                    height: "100%",
                  }}
                >
                  <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1.5 }}>
                    <Box
                      sx={{
                        width: 32,
                        height: 32,
                        borderRadius: borderRadiusPx.md,
                        bgcolor: colors.purple[100],
                        color: colors.purple[700],
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <StepIcon sx={{ fontSize: 18 }} />
                    </Box>
                    <Typography
                      variant="caption"
                      sx={{
                        fontWeight: 800,
                        color: colors.purple[400],
                        fontSize: "0.85rem",
                      }}
                    >
                      {item.step}
                    </Typography>
                  </Stack>
                  <Typography
                    variant="subtitle2"
                    sx={{ fontWeight: 700, color: colors.slate[900], mb: 0.5 }}
                  >
                    {item.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ color: colors.slate[600], fontSize: "0.82rem", lineHeight: 1.5 }}
                  >
                    {item.desc}
                  </Typography>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </Box>

      {/* Frequently Asked Questions */}
      {/* <Box
        sx={{
          bgcolor: colors.dashboard.cardBg,
          borderRadius: borderRadiusPx.xl,
          border: `1px solid ${colors.dashboard.cardBorder}`,
          p: { xs: 3, md: 4 },
        }}
      >
        <Typography
          variant="h6"
          sx={{ fontWeight: 700, color: colors.slate[900], mb: 2, fontSize: "1.05rem" }}
        >
          Frequently Asked Questions
        </Typography>

        <Stack spacing={1.5}>
          {FAQS.map((faq, index) => (
            <Accordion
              key={index}
              disableGutters
              elevation={0}
              sx={{
                border: `1px solid ${colors.slate[200]}`,
                borderRadius: `${borderRadiusPx.md} !important`,
                "&:before": { display: "none" },
                overflow: "hidden",
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: colors.slate[500] }} />}
                sx={{
                  bgcolor: colors.slate[50],
                  px: 2,
                  py: 0.5,
                  "& .MuiAccordionSummary-content": { my: 1 },
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{ fontWeight: 600, color: colors.slate[800] }}
                >
                  {faq.q}
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ px: 2, py: 1.5, bgcolor: colors.dashboard.cardBg }}>
                <Typography
                  variant="body2"
                  sx={{ color: colors.slate[600], lineHeight: 1.6 }}
                >
                  {faq.a}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Stack>
      </Box> */}
    </Box>
  );
};

export default MineHowToPlay;
